import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  LinearProgress,
} from "@mui/material";
import { get_admin_stats } from "../Api service/APIvariables";
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import MoneyOffRoundedIcon from '@mui/icons-material/MoneyOffRounded';
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import ContactMailRoundedIcon from '@mui/icons-material/ContactMailRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    total_users: 0,
    active_paid_users: 0,
    free_users: 0,
    revenue_this_month: 0,
    total_revenue: 0,
    cards_scanned_today: 0,
    emails_sent_today: 0
  });
  const [isLoading, setIsLoading] = useState(true);

  const fetchStats = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");
      if (!user_id || !token) return;

      const formData = new FormData();
      formData.append("user_id", user_id);

      const res = await fetch(get_admin_stats, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json();
      if (!data.error) {
        setStats(data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  if (isLoading) {
    return (
      <Box sx={{ width: '100%', mt: 4 }}>
        <LinearProgress color="secondary" />
      </Box>
    );
  }

  const statCards = [
    {
      title: "Total Users",
      value: stats.total_users,
      icon: <PeopleAltRoundedIcon sx={{ fontSize: 40, color: "#1976d2" }} />,
      bg: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
      color: "#0d47a1"
    },
    {
      title: "Active Paid Users",
      value: stats.active_paid_users,
      icon: <StarRoundedIcon sx={{ fontSize: 40, color: "#9c27b0" }} />,
      bg: "linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)",
      color: "#4a148c"
    },
    {
      title: "Free Users",
      value: stats.free_users,
      icon: <MoneyOffRoundedIcon sx={{ fontSize: 40, color: "#757575" }} />,
      bg: "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)",
      color: "#333333"
    },
    {
      title: "Revenue This Month",
      value: `₹${parseFloat(stats.revenue_this_month).toLocaleString()}`,
      icon: <TrendingUpRoundedIcon sx={{ fontSize: 40, color: "#2e7d32" }} />,
      bg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
      color: "#1b5e20"
    },
    {
      title: "Total Revenue",
      value: `₹${parseFloat(stats.total_revenue).toLocaleString()}`,
      icon: <AccountBalanceWalletRoundedIcon sx={{ fontSize: 40, color: "#e65100" }} />,
      bg: "linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)",
      color: "#e65100"
    },
    {
      title: "Cards Scanned Today",
      value: stats.cards_scanned_today,
      icon: <ContactMailRoundedIcon sx={{ fontSize: 40, color: "#00838f" }} />,
      bg: "linear-gradient(135deg, #e0f7fa 0%, #b2ebf2 100%)",
      color: "#006064"
    },
    {
      title: "Emails Sent Today",
      value: stats.emails_sent_today,
      icon: <EmailRoundedIcon sx={{ fontSize: 40, color: "#37474f" }} />,
      bg: "linear-gradient(135deg, #eceff1 0%, #cfd8dc 100%)",
      color: "#263238"
    }
  ];

  return (
    <Box sx={{ padding: 4, width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
      <Typography variant="h4" fontWeight="bold" sx={{ mb: 1, color: "#453c72" }}>
        Admin Dashboard
      </Typography>
      <Typography variant="subtitle1" color="textSecondary" sx={{ mb: 4 }}>
        Overview of key business metrics and operations.
      </Typography>

      <Grid container spacing={3}>
        {statCards.map((card, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <Card 
              elevation={2} 
              sx={{ 
                height: "100%", 
                background: card.bg, 
                color: card.color,
                borderRadius: 3,
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.1)"
                }
              }}
            >
              <CardContent sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 3 }}>
                <Box>
                  <Typography variant="body2" sx={{ opacity: 0.8, textTransform: "uppercase", fontWeight: "bold", mb: 0.5 }}>
                    {card.title}
                  </Typography>
                  <Typography variant="h3" fontWeight="bold">
                    {card.value}
                  </Typography>
                </Box>
                <Box sx={{ p: 1, borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.4)" }}>
                  {card.icon}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
